
<script>import Loader from '/app/components/Loader.html'
import parse from 'date-fns/parse'
import format from 'date-fns/format'

import differenceInHours from 'date-fns/difference_in_hours'
import differenceInMinutes from 'date-fns/difference_in_minutes'
import differenceInSeconds from 'date-fns/difference_in_seconds'


/* eslint-disable */
/**
 * NOTE: the following was hoisted from Tweetie.js
 * https://github.com/sonnyt/tweetie
 */
var linking = function (tweet) {
	var twit = tweet.replace(/(https?:\/\/([-\w\.]+)+(:\d+)?(\/([\w\/_\.]*(\?\S+)?)?)?)/ig,'<a href="$1" target="_blank" title="Visit this link">$1</a>')
		.replace(/#([a-zA-Z0-9_]+)/g,'<a href="https://twitter.com/search?q=%23$1&amp;src=hash" target="_blank" title="Search for #$1">#$1</a>')
		.replace(/@([a-zA-Z0-9_]+)/g,'<a href="https://twitter.com/$1" target="_blank" title="$1 on Twitter">@$1</a>');
	return twit;
};
// END OF HOIST!
/* eslint-enable */


export default {

	computed: {
		loaded: stories => !!stories,
	},

	oncreate() {
		// one time fetch
		fetch(this.get('url'))
			.then(response => response.json())
			.then(json => {
				const stories = _.map(_.filter(json, story => {
					/* eslint-disable camelcase */
					// return !story.retweeted && !story.in_reply_to_screen_name
					return !story.in_reply_to_screen_name
					/* eslint-enable */
				}), story => {

					const then = parse(story.created_at)
					const now = new Date()
					let timestamp = ''
					let diff = differenceInHours(now, then)
					if (diff < 24) {
						if (diff < 1) {
							diff = differenceInMinutes(now, then)
							if (diff < 1) {
								diff = differenceInSeconds(now, then)
								timestamp = `${diff}s`
							} else {
								timestamp = `${diff}m`
							}
						} else {
							timestamp = `${diff}h`
						}
					} else {
						timestamp = format(then, 'MMM d')
					}

					return {
						timestamp,
						href: 'https://twitter.com/' + story.user.screen_name + '/status/' + story.id_str,
						html: story.retweeted ?
							linking('RT @' + story.user.screen_name + ': ' + story.retweeted_status.text) :
							linking(story.text),
					}
				})
				this.set({
					username: linking('@' + json[0].user.screen_name),
					stories: stories.slice(0, 3),
				})
			})
			// TODO: handle errors gracefully?
			// .catch(ex => console.log('parsing failed', ex))

		// unfortunately, this is necessary to make sure
		// any page setup elsewhere is recalibrated
		this.observe('loaded', () => {
			setTimeout(() => {
				var resizeEvent = window.document.createEvent('UIEvents')
				resizeEvent.initUIEvent('resize', true, false, window, 0)
				window.dispatchEvent(resizeEvent)
			}, 0)
		})
	},

	components: {
		Loader,
	},

}

</script>{{#if loaded}}
<h2>{{{username}}}</h2>
<div class="items">{{#each stories as story}}
  <div class="item">
    <div class="tweet">{{{story.html}}}</div><a class="timestamp" href="{{story.href}}" target="_blank">{{story.timestamp}}</a>
  </div>{{/each}}
</div>{{else}}
<Loader></Loader>{{/if}}